module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "margin-20"
  }, [_c('FilterPageList', {
    attrs: {
      "data": _vm.zkClusterList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入集群ID"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.zkClusterKey.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.zkClusterKey, "value", $$v)
            },
            expression: "filters.zkClusterKey.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("ZK集群信息\n                            "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.getAllClusters
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [(_vm.$common.hasPerm('registryCenter:addZkCluster')) ? _c('el-button', {
          on: {
            "click": function($event) {
              _vm.handleAdd()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle text-btn"
        }), _vm._v("添加集群")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "zkClusterKey",
            "label": "ID",
            "width": "150px",
            "sortable": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zkAlias",
            "label": "名称",
            "width": "150px"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "offline",
            "label": "状态",
            "width": "100px"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('el-tag', {
                attrs: {
                  "type": scope.row.offline ? '' : 'success',
                  "close-transition": ""
                }
              }, [_vm._v(_vm._s(_vm.statusMap[scope.row.offline]))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "description",
            "label": "描述",
            "show-overflow-tooltip": true
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "zkAddr",
            "label": "连接串",
            "show-overflow-tooltip": true
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "80px",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.$common.hasPerm('registryCenter:addZkCluster')) ? _c('el-tooltip', {
                attrs: {
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text",
                  "icon": "el-icon-edit"
                },
                on: {
                  "click": function($event) {
                    _vm.handleEdit(scope.row)
                  }
                }
              })], 1) : _vm._e()]
            }
          }])
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.isClusterVisible) ? _c('div', [_c('cluster-info-dialog', {
    attrs: {
      "cluster-info": _vm.clusterInfo,
      "cluster-info-title": _vm.clusterInfoTitle,
      "cluster-info-operate": _vm.clusterInfoOperate
    },
    on: {
      "cluster-info-success": _vm.clusterInfoSuccess,
      "close-dialog": _vm.closeInfoDialog
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-931415e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/registry_manage/clusters_manage.vue
// module id = 1433
// module chunks = 1